export const AdvertisedProducts = [
  {
    id: 1,
    productName: 'File ITR Yourself',
    productDescription:
      'Quick and hassle-free self-filing that lets you submit your tax returns in just minutes.',
    bulletPoints: [
      'Complete in just 3 minutes',
      'Simple step-by-step guidance',
    ],
    ctaText: 'File Now',
    ctaLink: '/filing?&utm_ref=itr_partner_page',
    cardClasses: 'card1 sm:order-2',
    bulletImg:
      'https://assets.clear.in/cleartax/images/1746695358_checkcircle1.svg',
  },
  {
    id: 2,
    productName: 'File with Tax Experts',
    productDescription:
      'Choose from India’s top tax experts for a Premium, worry-free ITR filing experience.',
    bulletPoints: [
      'Live Tax filing with tax experts ',
      'Taxes done with 100% accuracy',
    ],
    ctaText: 'Book Your Expert',
    ctaLink: '#expert_assisted_plans',
    cardClasses: 'card2 sm:order-1',
    bulletImg:
      'https://assets.clear.in/cleartax/images/1746697630_checkcircle2.svg',
  },
];

export const AdvertisedFeatures = [
  {
    imgUrl: 'https://assets.clear.in/cleartax/images/1746694679_itrfiling.svg',
    description: 'No manual data entry',
  },
  {
    imgUrl:
      'https://assets.clear.in/cleartax/images/1746699022_salaryincome.svg',
    description: 'Maximum Refund',
  },
  {
    imgUrl: 'https://assets.clear.in/cleartax/images/1746699417_ai.svg',
    description: 'Built-in AI Support',
  },
  {
    imgUrl:
      'https://assets.clear.in/cleartax/images/1746699109_frame18142215244.svg',
    description: 'Data-Driven Tax Insight',
  },
];
